import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import React from "react";
import { Eye } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { useState } from "react";
import { blackUser } from "@/assets";

export function TimeSheetReportTable({ data }) {
  const [openShiftDetailsDialog, setShiftDetailsDialog] = useState(false);
  const [shifts, setShifts] = useState(null);

  const offDialog = () => {
    setShiftDetailsDialog(false);
    setShifts(null);
  };

  return (
    <>
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[100px]">ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Designations</TableHead>
            <TableHead>Time Sheet</TableHead>
            <TableHead className="text-right">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data.length > 0 ? (
            data?.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{item?.staff_id}</TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <img
                      src={item?.file_manager_url || blackUser}
                      alt={item?.name}
                      className="w-8 h-8 rounded-full"
                    />
                    <span>{item?.name || "N/A"}</span>
                  </div>
                </TableCell>
                <TableCell>{item?.designation || "N/A"}</TableCell>
                <TableCell>
                  {" "}
                  <span
                    onClick={() => {
                      setShifts(item);
                      setShiftDetailsDialog(true);
                    }}
                    className="cursor-pointer"
                  >
                    <Eye size={18} />
                  </span>
                </TableCell>
                <TableCell className="text-right">
                  <span className="text-cgreen text-[8px] flex items-center justify-end gap-1">
                    🟢<span className="text-base">{item?.status || "N/A"}</span>
                  </span>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={10} className="text-center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <ShiftDetailsDialog
        openShiftDetailsDialog={openShiftDetailsDialog}
        offDialog={offDialog}
        data={shifts}
      />
    </>
  );
}

export default TimeSheetReportTable;

export function ShiftDetailsDialog({
  openShiftDetailsDialog,
  offDialog,
  data,
}) {
  return (
    <Dialog open={openShiftDetailsDialog} onOpenChange={offDialog}>
      <DialogContent className="sm:max-w-[500px]">
        <div className="py-5 flex flex-col">
          <DialogTitle className="text-lg absolute top-4 font-medium">
            Shift Details : {data?.staff_id || "N/A"}
          </DialogTitle>
          <Separator className="mt-4" />
          <div className="py-5 flex flex-col">
            <div className="bg-cblack font-medium px-4 w-full flex py-2">
              <h2 className="w-32 ">Date</h2>
              <p>Time</p>
            </div>
            {data && data?.staff_schedule && data?.staff_schedule.length > 0 ? (
              data?.staff_schedule.map((item, val) => (
                <div
                  key={val}
                  className="mt-2 px-5 text-cwhite2 flex  py-3 border-b border-neutral-700"
                >
                  <p className="w-32 capitalize ">{item?.day || "N/A"}</p>
                  <div className="flex gap-2">
                    <span className="p-2 border border-neutral-600 hover:bg-cblack7 bg-cblack6 rounded text-sm cursor-pointer">
                      {item?.start_time || "00:00"} - {item?.end_time || "00:00"}
                    </span>
                    {/* <span className="p-2 border border-neutral-600 hover:bg-cblack7 bg-cblack6 rounded text-sm cursor-pointer">
                      04:00PM - 02:00AM
                    </span>
                    <span className="p-2 border border-neutral-600 hover:bg-cblack7 bg-cblack6 rounded text-sm cursor-pointer">
                      02:00AM - 04:00AM
                    </span> */}
                  </div>
                </div>
              ))
            ) : (
              <span>Data not available</span>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
